import React from 'react';
import { Contact } from 'components/contact/Contact';
import { RichText } from 'components/rich-text/RichText';

export const ContactBlockSlice = ({
  title,
  name,
  text,
  phone,
  email,
  linkedin,
  link,
  linkTagline,
  linkTitle,
  isSlice,
  isSplitPage,
}) => {
  return (
    <Contact
      title={title}
      name={name}
      text={RichText.render(text)}
      phone={phone}
      email={email}
      linkedin={linkedin}
      link={link}
      linkTitle={linkTitle}
      linkTagline={linkTagline}
      isSlice={isSlice}
      isSplitPage={isSplitPage}
    />
  );
};

export default ContactBlockSlice;
